<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="icon-wrapper">
          <fa-icon [icon]="faPlus"></fa-icon>
        </div>
        <div>
          <h2 class="modal-title">Nueva Oportunidad</h2>
          <p class="modal-subtitle">Introduce los datos para registrar un nuevo negocio.</p>
        </div>
      </div>
      <button class="btn-close" (click)="onClose()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <form [formGroup]="opportunityForm" (ngSubmit)="onSubmit()" class="opportunity-form">
        <!-- Sección Empresa -->
        <div class="form-section">
          <div class="section-title">
            <fa-icon [icon]="faBuilding"></fa-icon>
            <span>Datos de la Empresa</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- NIF -->
            <div class="form-group">
              <label for="nif">NIF / CIF <span class="required">*</span></label>
              <div class="relative">
                <input
                  type="text"
                  id="nif"
                  formControlName="nif"
                  class="app-input"
                  placeholder="B12345678"
                  (blur)="checkNif()"
                  [class.invalid]="f['nif'].invalid && f['nif'].touched"
                />
                @if (isNifChecking) {
                  <div class="input-spinner">
                    <div class="spinner"></div>
                  </div>
                }
              </div>
            </div>

            @if (companyFound) {
              <div class="company-found-card md:col-span-1">
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center gap-3">
                    <div class="success-icon">
                      <fa-icon [icon]="faCircleCheck"></fa-icon>
                    </div>
                    <div>
                      <span
                        class="block text-xs font-semibold text-gray-500 uppercase tracking-wider"
                        >Empresa Encontrada</span
                      >
                      <span
                        class="block text-sm font-bold text-emerald-700 dark:text-emerald-400"
                        >{{ foundCompanyName }}</span
                      >
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn-clear-company"
                    (click)="clearCompany()"
                    title="Cambiar empresa"
                  >
                    <fa-icon [icon]="faXmark"></fa-icon>
                  </button>
                </div>
              </div>
            } @else {
              <!-- Nombre -->
              <div class="form-group">
                <label for="name">Nombre de la Empresa <span class="required">*</span></label>
                <input
                  type="text"
                  id="name"
                  formControlName="name"
                  class="app-input"
                  placeholder="EMPRESA S.L."
                  [class.invalid]="f['name'].invalid && f['name'].touched"
                />
              </div>
            }
          </div>

          <!-- Campos que se ocultan si la empresa existe -->
          @if (!companyFound) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 animate-fadeIn">
              <div class="form-group">
                <label for="commercial_name">Nombre Comercial</label>
                <input
                  type="text"
                  id="commercial_name"
                  formControlName="commercial_name"
                  class="app-input"
                  placeholder="Nombre de marca"
                />
              </div>
              <div class="form-group">
                <label for="email">Email de contacto</label>
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  class="app-input"
                  placeholder="contacto@empresa.com"
                  [class.invalid]="f['email'].invalid && f['email'].touched"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 animate-fadeIn">
              <div class="form-group">
                <label for="phone">Teléfono</label>
                <input
                  type="text"
                  id="phone"
                  formControlName="phone"
                  class="app-input"
                  placeholder="900 000 000"
                />
              </div>
              <div class="form-group">
                <label for="address">Dirección</label>
                <input
                  type="text"
                  id="address"
                  formControlName="address"
                  class="app-input"
                  placeholder="Calle Ejemplo, 1, 28001 Madrid"
                />
              </div>
            </div>
          }
        </div>

        <!-- Sección Oportunidad -->
        <div class="form-section">
          <div class="section-title">
            <fa-icon [icon]="faBriefcase"></fa-icon>
            <span>Detalles de la Oportunidad</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="form-group md:col-span-2">
              <label for="deal_name"
                >Nombre de la Oportunidad <span class="required">*</span></label
              >
              <input
                type="text"
                id="deal_name"
                formControlName="deal_name"
                class="app-input"
                placeholder="Ej: Shopify"
                [class.invalid]="f['deal_name'].invalid && f['deal_name'].touched"
              />
            </div>
            <div class="form-group">
              <label for="amount">Presupuesto estimado (€) <span class="required">*</span></label>
              <select
                id="amount"
                formControlName="amount"
                class="app-input"
                [class.invalid]="f['amount'].invalid && f['amount'].touched"
              >
                <option [ngValue]="null" disabled>Selecciona una horquilla</option>
                <option *ngFor="let range of budgetRanges" [ngValue]="range.value">
                  {{ range.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- Productos (Múltiple) -->
          <div class="form-group mb-0">
            <label class="block text-sm font-semibold text-gray-500 mb-3">Productos interesados</label>
            <div class="products-container space-y-6">
              @for (group of groupedProducts; track group.id) {
                <div class="product-group">
                  <h4
                    class="group-header"
                    [class.selected]="isGroupSelected(group)"
                    role="button"
                    tabindex="0"
                    (click)="toggleGroup(group)"
                    (keydown.enter)="toggleGroup(group)"
                    (keydown.space)="$event.preventDefault(); toggleGroup(group)"
                  >
                    <fa-icon [icon]="faLayerGroup" class="text-blue-500/50"></fa-icon>
                    <span class="group-name">{{ group.name }}</span>
                    @if (isGroupSelected(group)) {
                      <fa-icon [icon]="faCircleCheck" class="group-check"></fa-icon>
                    }
                    <button
                      type="button"
                      class="expand-toggle"
                      [class.expanded]="isGroupExpanded(group)"
                      [attr.aria-label]="isGroupExpanded(group) ? 'Contraer' : 'Expandir'"
                      (click)="toggleGroupExpand(group, $event)"
                    >
                      <fa-icon [icon]="faChevronRight"></fa-icon>
                    </button>
                  </h4>
                  @if (isGroupExpanded(group)) {
                    <div class="products-grid animate-fadeIn">
                      @for (product of group.products; track product.id) {
                        <div
                          class="product-item has-tooltip"
                          (mouseenter)="updateTooltipPosition($event, product.id)"
                        >
                          <fa-icon [icon]="faTag" class="text-xs"></fa-icon>
                          <span class="product-name">{{ product.name }}</span>

                          <!-- Tooltip -->
                          <div class="product-tooltip" [ngClass]="tooltipPositions[product.id] || 'center'">
                            <div class="tooltip-header">
                              <fa-icon [icon]="faCircleInfo"></fa-icon>
                              <span>{{ product.name }}</span>
                            </div>
                            <div class="tooltip-body">
                              @if (product.description) {
                                <p class="description">{{ product.description }}</p>
                              }
                              <div class="value-range">
                                <span class="label">Valor estimado:</span>
                                <span class="value">{{ product.estimated_value || 'Consultar' }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="form-group mt-4">
            <label for="description"
              >Descripción / Notas adicionales
              <span class="text-xs font-normal text-gray-400 italic"
                >(Indicar datos de contacto y nombre de la persona)</span
              ></label
            >
            <textarea
              id="description"
              formControlName="description"
              class="app-input min-h-[100px]"
              placeholder="Añade cualquier detalle relevante sobre la oportunidad..."
            ></textarea>

            @if (productsPreview) {
              <div class="description-preview animate-fadeIn">
                <div class="preview-header">
                  <fa-icon [icon]="faCircleInfo"></fa-icon>
                  <span>Se añadirá a la descripción:</span>
                </div>
                <p class="preview-content">{{ productsPreview }}</p>
              </div>
            }
          </div>
        </div>

        <!-- Admin Only: Partner Selector -->
        @if (isAdmin) {
          <div class="form-section partner-section">
            <div class="section-title">
              <fa-icon [icon]="faHandshake"></fa-icon>
              <span>Partner <span class="required">*</span></span>
            </div>
            <div class="form-group">
              <select id="partner_id" formControlName="partner_id" class="app-input">
                <option value="">-- Seleccionar Partner --</option>
                @for (partner of partners; track partner.id) {
                  <option [value]="partner.id">{{ partner.company_name }}</option>
                }
              </select>
              @if (f['partner_id'].invalid && f['partner_id'].touched) {
                <div class="error-text">El partner es obligatorio para administradores</div>
              }
            </div>
          </div>
        }

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn-cancel" (click)="onClose()">Cancelar</button>
          <button type="submit" class="btn-submit" [disabled]="isLoading">
            @if (isLoading) {
              <div class="spinner spinner-white"></div>
              <span>Creando...</span>
            } @else {
              <span>Crear Oportunidad</span>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
